import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './right-panel.module.scss';
import 'react-sliding-side-panel/lib/index.css';
import SlidingPanel from 'react-sliding-side-panel';
import Close from '@/assets/icons/close-right-panel.svg';
import { useWindowDimensions } from '@/hooks';
import {LayoutObservable} from '@/observables/layout.observable';
const RightPanel = ({ children, isOpen, onClose, panelClass, containerClass}) => {
  const {isMobile, isTablet} = useWindowDimensions();

  useEffect(() => {
      LayoutObservable.toggleDisplayRightPanel(isOpen);

      return () => {
          LayoutObservable.toggleDisplayRightPanel(false);
      }
  }, [isOpen]);

  return (
      <SlidingPanel
        type={isMobile ? 'bottom' : 'right'}
        isOpen={isOpen}
        size={isMobile ? 100 : isTablet ? 50 : 35 }
        panelContainerClassName={`${containerClass && containerClass} ${styles.cgRightPanel__container}`}
        panelClassName={`${panelClass && panelClass} ${styles.cgRightPanel}`}
        noBackdrop
        backdropClicked={onClose}
      >
        <div className={styles.cgRightPanel__content}>
          {children}
          <button className={styles.cgRightPanel__closeButton} onClick={onClose}><Close /></button>
        </div>
      </SlidingPanel>
  )
}

RightPanel.propTypes = {
  containerClass: PropTypes.string,
  panelClass: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}

export default RightPanel;
